"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
/**
 * Error de API que conserva el cuerpo que envía el backend
 * ({ status, title, detail }) para poder mostrar un mensaje concreto
 * al usuario en lugar de un error genérico.
 */
class ApiError extends Error {
    status;
    title;
    detail;
    constructor(message, options = {}) {
        super(message);
        this.name = options.name ?? 'ApiError';
        this.status = options.status;
        this.title = options.title;
        this.detail = options.detail;
    }
}
exports.ApiError = ApiError;
